import { render, staticRenderFns } from "./VoucherTMF.vue?vue&type=template&id=1479f1fc&scoped=true&"
import script from "./VoucherTMF.vue?vue&type=script&lang=ts&"
export * from "./VoucherTMF.vue?vue&type=script&lang=ts&"
import style0 from "./VoucherTMF.vue?vue&type=style&index=0&id=1479f1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479f1fc",
  null
  
)

export default component.exports